export default "__VITE_ASSET__nAH0pGdk__"